/* global dataLayer */

export function gtmMicroconversions(eventType, eventDetail) {
  dataLayer.push({ event: 'microconversions', eventDetail, eventType });
}
